import React from 'react';
import {links} from '../index';
export const Project = (props) => {
    return (
        <a
            href={props.link}
            target='_blank'
            rel='noopener noreferrer'
            className='project-card'
        >
            <div className='project-content'>
                <div className='project-overlay-container'>
                    <div className='project-overlay'></div>
                </div>
                <div className='project-thumbnail-container'>
                    <div className='project-thumbnail'>
                        <img
                            src={`${props.link}.png`}
                            className='project-img'
                            style={{ opacity: props.opacity }}
                            aria-hidden='true'
                            alt=''
                        />
                    </div>
                </div>
                <div className='project-info'>
                    <span className='project-view'>
                        View Project
                    </span>
                    <span className='project-title'>
                        {props.title}
                    </span>
                </div>
            </div>
        </a>
    );
};
export const Projects = props => {
    return (
        <section
            id='projects-section'
            className='projects section'
        >
            <h2 className='projects-header section-header'>
                Projects
            </h2>
            <div className='projects-container'>
                {props.children}
            </div>
            <div className='projects-text'>
                <p>
                    Disclaimer: This website and the personal projects showcased here were all built around 2020 and are rather out-of-date. They do not accurately reflect my current capability as a full stack engineer, but they ARE fully completed projects, unlike anything more recent...
                </p>
                <p>
                    So, for a more accurate (but less visually presentable) representation of my current technical skillset, I recommend exploring my recent contributions on <a href={links.gitlab} target='_blank' rel='noopener noreferrer' className='link'>Gitlab</a>!
                </p>
            </div>
        </section>
    );
};
